export const METIERS = [
  { nom: 'Application', art: 'app',
    desc: 'Une application simple et agréable, pensée pour vos clients ou vos équipes.' },
  { nom: 'Assistant IA', art: 'ia',
    desc: 'Un assistant sur mesure qui répond à vos clients et prend en charge les tâches répétitives.' },
  { nom: 'Événementiel', art: 'event',
    desc: 'Des événements qui marquent les esprits, de l’idée au jour J.' },
  { nom: 'Identité visuelle', art: 'graph',
    desc: 'Logo, univers graphique et supports qui donnent du caractère à votre marque.' },
  { nom: 'Photo', art: 'photo',
    desc: 'Des images qui racontent votre histoire et donnent envie de vous découvrir.' },
  { nom: 'Publicité', art: 'pub',
    desc: 'Des campagnes ciblées pour toucher les bonnes personnes.' },
  { nom: 'Réseaux sociaux', art: 'social',
    desc: 'Des contenus réguliers, créatifs et pensés pour votre communauté.' },
  { nom: 'Site web', art: 'web',
    desc: 'Un site moderne, clair et pensé pour être visible sur Google.' },
  { nom: 'Vidéo', art: 'video',
    desc: 'Des films qui captent l’attention, du tournage au montage.' }
];
